import React, { useState, useEffect } from "react";

import {
	MuiThemeProvider,
	createMuiTheme,
	withStyles,
} from "@material-ui/core/styles";

import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import Typography from "@material-ui/core/Typography";
import Fade from "@material-ui/core/Fade";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Chip from "@material-ui/core/Chip";


import { DropzoneArea } from "material-ui-dropzone";
import ls from "local-storage";


import { validateEmail, validatePhoneNumber } from "../lndbtool/functions/participant-helpers";
import CompanyFilter from "./CompanyFilter";
import CompanyPriorities from "./CompanyPriorities";
import "./signupform.scss";
import { Hidden } from "@material-ui/core";


const theme = createMuiTheme({
	palette: {
		primary: {
			main: "#00b0d6",
			contrastText: "#FFFFFF",
		},
		secondary: {
			main: "#00c853",
			contrastText: "#FFFFFF",
		},
		red: "#ab003c",
	},
	typography: {
		fontFamily: "'Open Sans', Roboto, 'Segoe UI', 'Helvetica Neue', Arial",
		htmlFontSize: 19,
		fontSize: 16,
		useNextVariants: true,
		fontWeight: 300,
		h1: {
			fontSize: 30,
		},
		h2: {
			fontSize: 25,
			marginTop: "2rem",
			textAlign: "center",
		},
		h3: {
			fontSize: 20,
			textTransform: "none",
		},
		h3: {
			fontSize: 18,
		},
		body1: {
			fontSize: 16,
		},
		body2: {
			fontSize: 16,
		},
		button: {
			fontSize: 16,
		},
		caption: {
			fontSize: 14,
		},
		overline: {
			fontSize: 16,
		},
	},
});

const styles = () => ({
	content: {
		maxWidth: 1140,
		marginLeft: "auto",
		marginRight: "auto",
	},
	subgroup: {
		padding: 30,
	},
	formHeadline: {
		fontSize: "120%",
	},
	// progress: {
	// 	position: "absolute",
	// 	top: 0,
	// 	left: 0,
	// 	right: 0,
	// 	bottom: 0,
	// 	margin: "auto",
	// },
	stepper: {
		padding: 0,
	},
	uploadWrap: {
		marginTop: 16,
		textAlign: "center",
	},
	dropzone: {
		maxWidth: 700,
		marginLeft: "auto",
		marginRight: "auto",
		padding: 15,
		minHeight: 150,
		fontFamily: "'Open Sans', Roboto, 'Segoe UI', 'Helvetica Neue', Arial",
		fontSize: 16,
		"& p": {
			fontSize: 16,
		},
	},
	positionsFormControl: {
		width: "100%",
		marginTop: 16
	},
	positionsOutlinedInput: {
		paddingTop: 13,
		paddingBottom: 8,
		minHeight: 35
	},
	positionsSelect: {

	},
	positionsMenu: {
		background: "rgba(0, 0, 0, 0.5)",
		"& > div:nth-child(2)": {
			maxHeight: "calc(100vh - 150px)",
			bottom: 80
		}
	},
	jobPosition: {
		display: "block",
		overflow: "visible",
		height: "auto",
		fontSize: "120%"
	},
	subJobPosition: {
		paddingLeft: 30
	},
	fabSelectApply: {
		position: "fixed",
		right: 20,
		bottom: 20,
		zIndex: 1301,
		pointerEvents: "none",

		"& svg": {
			marginRight: 8
		}
	},
	button: {
		marginTop: 10,
		marginRight: 10,
	},
	actionsContainer: {
		textAlign: "center",
		paddingTop: 10,
		paddingBottom: 20,
		marginTop: 30,
		marginBottom: 20,
	},
	stepper: {
		marginBottom: 60
	},
	activeStepLabel: {
		"@media (max-width: 500px)": {
			marginLeft: -30,
			marginRight: -30,
			width: "calc(100% + 60px)"
		}
	}
});

const url = window.location.href;
const splitted_url = url.split("/");
const restUrl =
	window.restUrl ||
	splitted_url[0] + "//" + splitted_url[2] + "/wp-json/lndb/v1/";

const SignupForm = ({ event_id, language, is_preview, classes }) => {
	//const classes = useStyles();
	const [fields, setFields] = React.useState({});
	const [companies, setCompanies] = React.useState([]);
	const [filteredCompanyIDs, setFilteredCompanyIDs] = React.useState([]);
	const [contentLoaded, setContentLoaded] = React.useState(false);
	const [signupstatus, setSignupstatus] = React.useState({});
	const [formphase, setFormphase] = React.useState('loading');
	const [activeStep, setActiveStep] = useState(0);
	const [participant, setParticipant] = useState({});
	const [fieldErrors, setFieldErrors] = useState({});
	const [fieldShowErrors, setFieldShowErrors] = useState({});
	const [rerenderKey, setRerenderKey] = useState(0);
	const [formErrors, setFormErrors] = useState([]);
	const [isJobTypesEnabled, setIsJobTypesEnabled] = useState(false);
	const [favorites, setFavorites] = useState([]);

	const steps = language === "en"
		? ["Find jobs", "Priorities", "About you", "Submit"]
		: ["Jobs finden", "Prioritäten", "Über dich", "Absenden"];


	const checkFormForErrors = (participantToCheck, fieldsToCheck = null) => {
		if (formphase !== "registration")
			return;

		if (!participantToCheck || Object.keys(participantToCheck).length === 0)
			participantToCheck = participant;
		if (Object.keys(participantToCheck).length === 0) return;
		if (!fieldsToCheck || Object.keys(fieldsToCheck).length === 0)
			fieldsToCheck = fields;

		let newFormErrors = [];

		const newFieldErrors = fieldErrors;
		Object.keys(participantToCheck).forEach((accessor) => {
			const field = fieldsToCheck[accessor];
			const value = participantToCheck[accessor];
			newFieldErrors[accessor] = "";
			if (field.required) {
				if (value === "" || value === false || !value || value.length === 0) {
					if (language === "en") {
						newFieldErrors[accessor] = "This field is mandatory";
						newFormErrors.push(
							"Please fill in all required fields before proceeding to the next step. "
						);
					} else {
						newFieldErrors[accessor] = "Das ist ein Pflichtfeld";
						newFormErrors.push(
							"Bitte fülle erst alle Pflichtfelder aus bevor du zum nächsten Schritt weiter gehst."
						);
					}
				}
			}
			if (field.column_type === "email" && !validateEmail(value)) {
				if (language === "en") {
					newFieldErrors[accessor] = "Please enter a valid email address.";
					newFormErrors.push("Please enter a valid email address.");
				} else {
					newFieldErrors[accessor] = "Bitte gib eine gültige E-Mail Adresse ein.";
					newFormErrors.push("Bitte gib eine gültige E-Mail Adresse ein.");
				}
			}
			if (field.column_type === "phone" && !validatePhoneNumber(value)) {
				if (language === "en") {
					newFieldErrors[accessor] = "Please enter your full mobile number without slash or brackets.";
					newFormErrors.push("Please enter your full mobile number without slash or brackets.");
				} else {
					newFieldErrors[accessor] = "Bitte gib deine vollständige Mobilnummer ohne Schrägstrich oder Klammern ein.";
					newFormErrors.push("Bitte gib deine vollständige Mobilnummer ohne Schrägstrich oder Klammern ein.");
				}
			}
			if (accessor.endsWith('_jobpositions')) {
				// if (value.length > 5) {
				// 	if (language === "en") {
				// 		newFieldErrors[accessor] = "You can apply to a maximum of five job positions per company.";
				// 		newFormErrors.push("You can apply to a maximum of five job positions per company.");
				// 	} else {
				// 		newFieldErrors[accessor] = "Du kannst dich pro Unternehmen für maximal fünf Stellen bewerben.";
				// 		newFormErrors.push("Du kannst dich pro Unternehmen für maximal fünf Stellen bewerben.");
				// 	}
				// }

				if (value.length === 0) {
					if (participantToCheck[accessor.replace('_jobpositions', '')] !== "") {
						if (language === "en") {
							newFieldErrors[accessor] = "This field is mandatory";
							newFormErrors.push(
								"Please fill in all required fields before proceeding to the next step. "
							);
						} else {
							newFieldErrors[accessor] = "Das ist ein Pflichtfeld";
							newFormErrors.push(
								"Bitte fülle erst alle Pflichtfelder aus bevor du zum nächsten Schritt weiter gehst."
							);
						}
					}
				}
			}
		});

		newFormErrors = newFormErrors.filter(
			(value, index, self) => self.indexOf(value) === index
		); //unique

		setFieldErrors(newFieldErrors);
		setFormErrors(newFormErrors);
		return { formErrors: newFormErrors, fieldErrors: newFieldErrors };
	};

	const mergeNewParticipantWithLocalStorage = (
		emptyParticipant,
		newFields,
		newCompanies
	) => {
		const localStoredParticipant = null;
		try {
			ls.get("participant");
		} catch (e) {
			// console.log(e);
		}
		const company_fields = [
			"company_1",
			"company_2",
			"company_3",
			"company_4",
			"company_5",
			"company_6",
			"company_7",
			"company_8",
			"company_9",
		];
		const newFilteredCompanyIDs = [];
		Object.keys(newFields).forEach((accessor) => {
			if (
				localStoredParticipant &&
				localStoredParticipant[accessor] &&
				newFields[accessor].column_type !== "file"
			) {
				emptyParticipant[accessor] = localStoredParticipant[accessor];

				if (company_fields.includes(accessor)) {
					newCompanies.forEach((company, index) => {
						newFilteredCompanyIDs.push(company.ID);
					});
				}
			}
		});


		setParticipant(emptyParticipant);
		setFields(newFields);
		setCompanies(newCompanies);
		setFilteredCompanyIDs(newFilteredCompanyIDs);
		setTimeout(() => {
			checkFormForErrors(emptyParticipant, newFields);
		}, 3000);
	};

	useEffect(() => {
		// scroll to #lndb-signupform
		if (activeStep > 0) {
			const element = document.getElementById("lndb-signupform");
			if (element) {
				setTimeout(() => {
					element.scrollIntoView({ behavior: "smooth" });
				}, 600);
			}
		}
	}, [activeStep]);

	useEffect(() => {
		var request = new Request(restUrl + "formdata?event_id=" + event_id + (is_preview ? "&mode=preview" : "") + "&language=" + language, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			credentials: "same-origin",
		});
		fetch(request)
			.then((resp) => resp.json())
			.then((data) => {
				const newFields = {};
				const newCompanies = [];
				const emptyParticipant = {};
				const emptyFieldErrors = {};
				const emptyFieldShowErrors = {};

				data.fields.forEach((field) => {
					emptyParticipant[field.accessor] = "";
					if (field.column_type === "checkbox")
						emptyParticipant[field.accessor] = false;
					if (field.column_type === "multiselect")
						emptyParticipant[field.accessor] = [];

					emptyFieldErrors[field.accessor] = "";
					emptyFieldShowErrors[field.accessor] = false;
					newFields[field.accessor] = field;
				});
				data.companies.forEach((company) => {

					newCompanies.push({ ...company, available: true });
				});

				mergeNewParticipantWithLocalStorage(
					emptyParticipant,
					newFields,
					newCompanies
				);
				setContentLoaded(true);
				setIsJobTypesEnabled(data.job_types_enabled);
				setFieldErrors(emptyFieldErrors);
				setFieldShowErrors(emptyFieldShowErrors);
				setSignupstatus(data.status);
				setFormphase(data.status.status);
			});

		const localStoredFavorites = null;
		try {
			ls.get("favorites");
		} catch (e) {
			// console.log(e);
		}
		if (localStoredFavorites) {
			setFavorites(localStoredFavorites);
		}
	}, []);

	useEffect(() => {
		try {
			ls.set("favorites", favorites);
		} catch (e) {
			// console.log(e);
		}
		if (participant.companies_to_exclude && participant.companies_to_exclude.length > 0) {
			const new_companies_to_exclude = participant.companies_to_exclude;
			for (const favorite of favorites) {
				if (new_companies_to_exclude.indexOf(favorite.id) > -1) {
					// remove favorite from companies_to_exclude
					new_companies_to_exclude.splice(new_companies_to_exclude.indexOf(favorite.id), 1);
					const newParticipant = { ...participant, companies_to_exclude: new_companies_to_exclude };
					setParticipant(newParticipant);
					try {
						ls.set("participant", newParticipant);
					} catch (e) {
						// console.log(e);
					}
				}
			}
		}
	}, [favorites]);

	const signup = () => {
		const formData = new FormData();
		Object.keys(participant).forEach((key) => {
			if (key === "vita" && participant[key] && participant[key].length) {
				participant.vita.forEach((file, index) => {
					formData.append("vita_" + index, file);
				});
			} else formData.append(key, participant[key]);
		});

		setSignupstatus({ ...signupstatus, waiting: true });

		formData.append("event_id", event_id);
		formData.append("language", language);
		var request = new Request(restUrl + "signup", {
			method: "POST",
			body: formData,
		});
		fetch(request)
			.then((resp) => {
				if (!resp.ok) {
					if (language === "en") {
						alert(
							"Your submission could not be saved. Please refresh the page and try again."
						);
					} else {
						alert(
							"Deine Anmeldung konnte nicht gespeichert werden. Bitte lade die Seite neu und versuch es nochmal."
						);
					}
				}
				return resp;
			})
			.then((resp) => resp.json())
			.then((data) => {
				const newSignupStatus = { ...signupstatus };
				newSignupStatus.result = data.status;
				newSignupStatus.waiting = false;

				if (data.status.success) {
					setActiveStep((prevActiveStep) => prevActiveStep + 1);
					setSignupstatus(newSignupStatus);
				} else {
					alert(data.status.error_msg);
					setSignupstatus({ ...signupstatus, waiting: false });
				}
			});
	};

	const submit = () => {
		signup();
		//RESET
		try {
			ls.set("participant", {});
			ls.set("favorites", []);
		} catch (e) {
			// console.log(e);
		}
		// window.location.reload();
	};

	const handleBack = () => {
		checkFormForErrors(participant);
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleFileUpload = (files) => {
		const newParticipant = { ...participant };
		newParticipant.vita = files;
		console.log(files);
		setParticipant(newParticipant);
		checkFormForErrors(newParticipant);
	};

	const handleFieldChange = (e) => {
		// console.log(e.target);
		const newParticipant = participant;
		const newFieldShowErrors = fieldShowErrors;
		const company_fields = [
			"company_1",
			"company_2",
			"company_3",
			"company_4",
			"company_5",
			"company_6",
			"company_7",
			"company_8",
			"company_9",
		];
		let value = e.target.value;

		// once the field has been modified show errors (if necessary)
		newFieldShowErrors[e.target.name] = true;

		if (fields[e.target.name].column_type === "checkbox")
			newParticipant[e.target.name] = e.target.checked;
		else if (fields[e.target.name].column_type === "multiselect") {
			if (newParticipant[e.target.name].indexOf(e.target.value) > -1) {
				newParticipant[e.target.name].splice(
					newParticipant[e.target.name].indexOf(e.target.value),
					1
				);
			} else {
				newParticipant[e.target.name].push(e.target.value);
			}
		} else newParticipant[e.target.name] = value;

		setParticipant(newParticipant);
		try {
			ls.set("participant", newParticipant);
		} catch (e) {
			// console.log(e);
		}
		setRerenderKey(rerenderKey + 1);
		checkFormForErrors(newParticipant);
		setFieldShowErrors(newFieldShowErrors);
	};

	const printContactFields = () => {
		const fieldgroups = [];
		fieldgroups.push(
			<div key="contact-fields">
				<Grid container spacing={16}>
					<Grid item xs={12} sm={2}>
						<TextField
							id="salutation"
							name="salutation"
							select
							label={fields.salutation.label}
							value={participant.salutation}
							onChange={handleFieldChange}
							helperText={
								fieldShowErrors.salutation ? fieldErrors.salutation : ""
							}
							error={
								fieldErrors.salutation !== "" && fieldShowErrors.salutation
							}
							variant="outlined"
							fullWidth
							margin="normal"
							required={fields.salutation.required}
						>
							<MenuItem value="">-</MenuItem>
							{fields.salutation.options.map((option) => (
								<MenuItem key={option.value} value={option.value}>
									{language === "en" ? option.label_EN : option.label}
								</MenuItem>
							))}
						</TextField>
					</Grid>
					<Grid item xs={12} sm={5}>
						<TextField
							id="firstname"
							name="firstname"
							label={fields.firstname.label}
							value={participant.firstname}
							onChange={handleFieldChange}
							helperText={
								fieldShowErrors.firstname ? fieldErrors.firstname : ""
							}
							error={fieldErrors.firstname !== "" && fieldShowErrors.firstname}
							variant="outlined"
							fullWidth
							margin="normal"
							required={fields.firstname.required}
						/>
					</Grid>
					<Grid item xs={12} sm={5}>
						<TextField
							id="lastname"
							name="lastname"
							label={fields.lastname.label}
							value={participant.lastname}
							onChange={handleFieldChange}
							helperText={fieldShowErrors.lastname ? fieldErrors.lastname : ""}
							error={fieldErrors.lastname !== "" && fieldShowErrors.lastname}
							variant="outlined"
							fullWidth
							margin="normal"
							required={fields.lastname.required}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="email"
							name="email"
							label={fields.email.label}
							value={participant.email}
							onChange={handleFieldChange}
							helperText={fieldShowErrors.email ? fieldErrors.email : (language === "en" ? "Please make sure this is a valid email address. Otherwise you wont receive your event informations." : "Bitte kontrolliere deine E-Mail Adresse sorgfältig, nur so erhältst du deine Teilnahmeinformationen.")}
							error={fieldErrors.email !== "" && fieldShowErrors.email}
							variant="outlined"
							fullWidth
							margin="normal"
							type="email"
							required={fields.email.required}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="phone"
							name="phone"
							label={fields.phone.label}
							value={participant.phone}
							onChange={handleFieldChange}
							helperText={fieldShowErrors.phone ? fieldErrors.phone : (language === "en" ? "Please us a mobile phone number, we will send important informations via SMS." : "Bitte gib uns deine Mobilnummer, wir schicken dir dringende Benachrichtigungen per SMS.")}
							error={fieldErrors.phone !== "" && fieldShowErrors.phone}
							variant="outlined"
							placeholder="+43664..."
							fullWidth
							margin="normal"
							type="phone"
							required={fields.phone.required}
						/>
					</Grid>

					{fields.hasOwnProperty('job_status') &&
						<Grid item xs={12} sm={6}>

							<TextField
								id="job_status"
								name="job_status"
								select
								label={fields.job_status.label}
								value={participant.job_status}
								onChange={handleFieldChange}
								helperText={
									fieldShowErrors.job_status ? fieldErrors.job_status : ""
								}
								error={
									fieldErrors.job_status !== "" && fieldShowErrors.job_status
								}
								variant="outlined"
								fullWidth
								margin="normal"
								required={fields.job_status.required}
							>
								<MenuItem value="">-</MenuItem>
								{fields.job_status.options.map((option) => (
									<MenuItem key={option.value} value={option.value}>
										{language === "en" ? option.label_EN : option.label}
									</MenuItem>
								))}
							</TextField>
						</Grid>
					}
					{fields.hasOwnProperty('formerrole') &&
						<Grid item xs={12} sm={6}>
							<TextField
								id="formerrole"
								name="formerrole"
								label={fields.formerrole.label}
								value={participant.formerrole}
								onChange={handleFieldChange}
								helperText={
									fieldShowErrors.formerrole ? fieldErrors.formerrole : ""
								}
								error={
									fieldErrors.formerrole !== "" && fieldShowErrors.formerrole
								}
								variant="outlined"
								fullWidth
								margin="normal"
								required={fields.formerrole.required}
							/>
						</Grid>
					}
					{fields.hasOwnProperty('german') &&
						<Grid item xs={12} sm={6}>
							<TextField
								id="german"
								name="german"
								select
								label={fields.german.label}
								value={participant.german}
								onChange={handleFieldChange}
								helperText={
									fieldShowErrors.german ? fieldErrors.german : ""
								}
								error={
									fieldErrors.german !== "" && fieldShowErrors.german
								}
								variant="outlined"
								InputLabelProps={{ shrink: true }}
								fullWidth
								margin="normal"
								required={fields.german.required}
							>
								{fields.german.options.map((option) => (
									<MenuItem key={option.value} value={option.value}>
										{language === "en" ? option.label_EN : option.label}
									</MenuItem>
								))}
							</TextField>
						</Grid>
					}
					{fields.hasOwnProperty('english') &&
						<Grid item xs={12} sm={6}>
							<TextField
								id="english"
								name="english"
								select
								label={fields.english.label}
								value={participant.english}
								onChange={handleFieldChange}
								helperText={
									fieldShowErrors.english ? fieldErrors.english : ""
								}
								error={
									fieldErrors.english !== "" && fieldShowErrors.english
								}
								variant="outlined"
								InputLabelProps={{ shrink: true }}
								fullWidth
								margin="normal"
								required={fields.english.required}
							>
								{fields.english.options.map((option) => (
									<MenuItem key={option.value} value={option.value}>
										{language === "en" ? option.label_EN : option.label}
									</MenuItem>
								))}
							</TextField>
						</Grid>
					}
					{fields.hasOwnProperty('education') &&
						<Grid item xs={12} sm={6}>
							<TextField
								id="education"
								name="education"
								label={fields.education.label}
								value={participant.education}
								onChange={handleFieldChange}
								helperText={
									fieldErrors.education && fieldShowErrors.education
										? fieldErrors.education
										: (
											language === "en"
												? "Tell us your highest educational degree (not the title, but the field) and further education or training that is important for your applications."
												: "Nenne uns hier deinen höchsten Ausbildungs­abschluss (nicht den Titel, sondern den Fachbereich) und jene Ausbildung, die für deine Bewerbungen wichtig ist."
										)
								}
								error={fieldErrors.education !== "" && fieldShowErrors.education}
								variant="outlined"
								fullWidth
								multiline
								rows="5"
								margin="normal"
								required={fields.education.required}
							/>
						</Grid>
					}
					{fields.hasOwnProperty('school') &&
						<Grid item xs={12} sm={6}>
							<TextField
								id="school"
								name="school"
								label={fields.school.label}
								value={participant.school}
								onChange={handleFieldChange}
								helperText={
									fieldShowErrors.school ? fieldErrors.school : ""
								}
								error={
									fieldErrors.school !== "" && fieldShowErrors.school
								}
								variant="outlined"
								fullWidth
								margin="normal"
								required={fields.school.required}
							/>
						</Grid>
					}
					<Grid item xs={12} sm={6}>
						<TextField
							id="notes"
							name="notes"
							label={fields.notes.label}
							value={participant.notes}
							onChange={handleFieldChange}
							helperText={fieldShowErrors.notes ? fieldErrors.notes : ""}
							error={fieldErrors.notes !== "" && fieldShowErrors.notes}
							variant="outlined"
							fullWidth
							multiline
							rows="5"
							margin="normal"
							required={fields.notes.required}
						/>
					</Grid>
					<Grid item xs={12}>
						{/* {participant.vita && participant.vita.length > 0 && (
							<>
								{participant.vita.map((file, index) => (
									<Chip key={index} label={file.name} onDelete={() => {
										const newFiles = [...participant.vita];
										newFiles.splice(index, 1);
										handleFileUpload(newFiles);
									}} />
								))}
							</>
						)} */}
						<div className={classes.uploadWrap}>
							{/* https://www.npmjs.com/package/material-ui-dropzone */}
							<DropzoneArea
								dropzoneClass={classes.dropzone}
								clearOnUnmount={false}
								onChange={(files) => {
									handleFileUpload(files);
								}}
								previewGridClasses={{
									container: classes.dropzonePreviewContainer,
									item: classes.dropzonePreviewItem,
								}}
								acceptedFiles={[
									"application/pdf",
									"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
									"application/msword",
									"image/png",
									"image/jpeg",
									"image/gif",
								]}
								filesLimit={3}
								maxFileSize={20000000}
								showPreviewsInDropzone={true}
								showPreviews={false}
								useChipsForPreview={false}
								showFileNamesInPreview={true}
								showFileNames={true}
								//initialFiles={participant.vita ? participant.vita : []}
								dropzoneText={
									participant.vita && participant.vita.length > 0 ? (
										language === "en"
											? "✓ CV/resume uploaded."
											: "✓ Lebenslauf hochgeladen."
									) : (
										language === "en"
											? "Drop CV/resume here or click to select."
											: "Lebenslauf hier ablegen oder zum Auswählen klicken."
									)
								}
								getFileLimitExceedMessage={(filesLimit) => {
									if (language === "en")
										return (
											"Maximum allowed number of files exceeded. Only " + filesLimit + " allowed"
										);
									return (
										"Zu viele Dateien. Es sind maximal " +
										filesLimit +
										" erlaubt."
									);
								}}
								getFileAddedMessage={(fileName) => {
									if (language === "en")
										return "Loading file " + fileName;
									return "Datei " + fileName + " wird geladen.";
								}}
								getFileRemovedMessage={(fileName) => {
									if (language === "en")
										return "File " + fileName + " removed.";
									return "Datei " + fileName + " entfernt.";
								}}
								getDropRejectMessage={(
									rejectedFile,
									acceptedFiles,
									maxFileSize
								) => {
									var message =
										"Die Datei " +
										rejectedFile.name +
										" kann nicht verwendet werden. ";
									if (language === "en")
										message =
											"File " +
											rejectedFile.name +
											" cannot be uploaded.";

									if (!acceptedFiles.includes(rejectedFile.type)) {
										if (language === "en")
											message +=
												"Only PDF, images and MS Word documents allowed.";
										else
											message +=
												"Es sind nur PDF, Bild und Word Dateien möglich.";
									}

									if (rejectedFile.size > maxFileSize) {
										if (language === "en")
											message +=
												"This file is too large. Maximum upload size is 20 MB";
										else
											message +=
												"Die Datei ist zu groß. Es sind maximal  20 MB möglich.";
									}

									return message;
								}}
							/>
						</div>
						{fieldShowErrors.vita && <Typography align="center" color="error">{fieldErrors.vita}</Typography>}
					</Grid>
				</Grid>
			</div>
		);
		return <>{fieldgroups}</>;
	};

	const printOtherFields = () => {
		const fieldgroups = [];
		fieldgroups.push(
			<div key="other-fields">
				<Grid container spacing={16}>
					<Grid item xs={12} sm={6}>
						<TextField
							id="find_us"
							name="find_us"
							select
							label={fields.find_us.label}
							value={participant.find_us}
							onChange={handleFieldChange}
							helperText={fieldShowErrors.find_us ? fieldErrors.find_us : ""}
							error={fieldErrors.find_us !== "" && fieldShowErrors.find_us}
							variant="outlined"
							fullWidth
							margin="normal"
							required={fields.find_us.required}
						>
							<MenuItem value="">-</MenuItem>
							{fields.find_us.options.map((option) => (
								<MenuItem key={option.value} value={option.value}>
									{language === "en" ? option.label_EN : option.label}
								</MenuItem>
							))}
						</TextField>
					</Grid>
					<Grid item xs={12} sm={6}>
						<Collapse in={participant.find_us === "Sonstiges"}>
							<TextField
								id="find_us_other"
								name="find_us_other"
								label={fields.find_us_other.label}
								value={participant.find_us_other}
								onChange={handleFieldChange}
								helperText={
									fieldShowErrors.find_us_other ? fieldErrors.find_us_other : ""
								}
								error={
									fieldErrors.find_us_other !== "" &&
									fieldShowErrors.find_us_other
								}
								variant="outlined"
								fullWidth
								margin="normal"
								required={fields.find_us_other.required}
							/>
						</Collapse>
					</Grid>

					<Grid item xs={12}>
						<FormControl
							required={fields.accept_privacy.required}
							error={
								fieldErrors.accept_privacy !== "" &&
								fieldShowErrors.accept_privacy
							}
						>
							<FormControlLabel
								control={
									<Checkbox
										id="accept_privacy"
										name="accept_privacy"
										checked={participant.accept_privacy}
										onChange={handleFieldChange}
									/>
								}
								label={
									<span
										dangerouslySetInnerHTML={{
											__html: fields.accept_privacy.label + " *",
										}}
									/>
								}
							/>
							<FormHelperText>
								{fieldShowErrors.accept_privacy
									? fieldErrors.accept_privacy
									: ""}
							</FormHelperText>
						</FormControl>
					</Grid>
					<Grid item xs={12}>
						<FormControl
							required={fields.accept_terms.required}
							error={
								fieldErrors.accept_terms !== "" && fieldShowErrors.accept_terms
							}
						>
							<FormControlLabel
								control={
									<Checkbox
										id="accept_terms"
										name="accept_terms"
										checked={participant.accept_terms}
										onChange={handleFieldChange}
									/>
								}
								label={
									<span
										dangerouslySetInnerHTML={{
											__html: fields.accept_terms.label + " *",
										}}
									/>
								}
							/>
							<FormHelperText>
								{fieldShowErrors.accept_terms ? fieldErrors.accept_terms : ""}
							</FormHelperText>
						</FormControl>
					</Grid>
					{fields.hasOwnProperty('powerserve') &&
						<Grid item xs={12}>
							<FormControl
								required={fields.powerserve.required}
								error={
									fieldErrors.powerserve !== "" && fieldShowErrors.powerserve
								}
							>
								<FormControlLabel
									control={
										<Checkbox
											id="powerserve"
											name="powerserve"
											checked={participant.powerserve}
											onChange={handleFieldChange}
										/>
									}
									label={
										<span
											dangerouslySetInnerHTML={{
												__html: fields.powerserve.label,
											}}
										/>
									}
								/>
								<FormHelperText>
									{fieldShowErrors.powerserve ? fieldErrors.powerserve : ""}
								</FormHelperText>
							</FormControl>
						</Grid>
					}
					{fields.hasOwnProperty('accept_newsletter') &&
						<Grid item xs={12}>
							<FormControl
								required={fields.accept_newsletter.required}
								error={
									fieldErrors.accept_newsletter !== "" &&
									fieldShowErrors.accept_newsletter
								}
							>
								<FormControlLabel
									control={
										<Checkbox
											id="accept_newsletter"
											name="accept_newsletter"
											checked={participant.accept_newsletter}
											onChange={handleFieldChange}
										/>
									}
									label={fields.accept_newsletter.label}
								/>
								<FormHelperText>
									{fieldShowErrors.accept_newsletter
										? fieldErrors.accept_newsletter
										: ""}
								</FormHelperText>
							</FormControl>
						</Grid>
					}
					{/* <Grid item xs={12}>
						<br />
						<Typography>
							Zum Schluss möchten wir dich einladen, eine Karriere Frage hier zu lassen, von der du denkst, dass auch andere von der Antwort lernen könnten. <br/>Was wolltest du schon immer von Doria oder einem Personalverantwortlichen wissen?  <br/>Schreibe uns hier deine Frage, diese wird anonym auf www.karrieregarage.com beantwortet.
						</Typography>
						<TextField
							id="karrieregarage"
							name="karrieregarage"
							label="Deine Frage"
							value={participant.karrieregarage}
							onChange={handleFieldChange}
							error={
								fieldErrors.karrieregarage !== "" &&
								fieldShowErrors.karrieregarage
							}
							variant="outlined"
							fullWidth
							multiline
							rows="5"
							margin="normal"
							required={fields.karrieregarage.required}
						/>
					</Grid> */}
				</Grid>
			</div>
		);
		return <>{fieldgroups}</>;
	};

	const printResults = () => {
		document.getElementById("lndb-signupform").scrollIntoView();

		if (!signupstatus.result) return <></>;
		else if (signupstatus.result.success)
			if (language === "en") {
				return (
					<>
						<br />
						<br />
						<Typography variant="h3">
							THANK YOU FOR YOUR SUBMISSION.
						</Typography>
						<Typography>
							Please check your mailbox. You should have received a copy of your submission.
						</Typography>
						<Typography>
							If not please contact us: {" "}
							<a href="mailto:info@doria.at">info@doria.at</a>
						</Typography>
						<Typography>
							P.S.: Please also check your junk folder and mark our mails as "no junk" so you wont miss any future informations.
						</Typography>
						<br />
					</>
				);
			} else {
				return (
					<>
						<br />
						<br />
						<Typography variant="h3">
							DANKE, WIR HABEN DEINE ANMELDUNG ERHALTEN.
						</Typography>
						<Typography>
							Bitte überprüfe gleich dein Postfach ob du die Kopie deiner
							Anmeldung erhalten hast.
						</Typography>
						<Typography>
							Wenn das nicht der Fall ist, melde dich bitte unter{" "}
							<a href="mailto:info@doria.at">info@doria.at</a>
						</Typography>
						<Typography>
							P.S.: Bitte sieh zur Sicherheit auch in deinem SPAM-Ordner nach. Falls die Mail tatsächlich im SPAM-Ordner gelandet ist, dann kennzeichne die Mail bitte als „Kein Spam“ damit du zukünftig keine Mail mehr verpasst.
						</Typography>
						<br />
					</>
				);
			}

		return <Typography>{signupstatus.result.error_msg}</Typography>;
	};
	return (
		<MuiThemeProvider theme={theme}>
			<CssBaseline />

			<main className={classes.content}>
				{!contentLoaded && (
					<Grid container justify="center" alignItems="center" spacing={16}>
						<Grid item>
							<CircularProgress className={classes.progress} color="secondary" />
						</Grid>
						<Grid item>
							<Typography>{language === "en" ? "Loading companies..." : "Firmen werden geladen..."}</Typography>
						</Grid>
					</Grid>
				)}
				<Fade in={contentLoaded && signupstatus && !signupstatus.success && formphase !== 'pre_registration' && formphase !== 'post_registration'}>
					<Typography align="center">{signupstatus.error_msg}</Typography>
				</Fade>
				{signupstatus.result && (
					<>{printResults()}</>
				)}
				{!signupstatus.result && formphase === "registration" && (
					<Stepper activeStep={activeStep} className={classes.stepper} alternativeLabel>
						{steps.map((label, index) => (
							<Step key={label}>
								<StepLabel>
									{index === activeStep ?
										<div className={classes.activeStepLabel}>{label}</div>
										:
										<Hidden smDown>{label}</Hidden>
									}
								</StepLabel>
							</Step>
						))}
					</Stepper>
				)}
				{activeStep === 0 && !signupstatus.result && contentLoaded && ["pre_registration", "post_registration", "registration"].indexOf(formphase) > -1 && (
					<CompanyFilter
						companies={companies}
						setFilteredCompanyIDs={setFilteredCompanyIDs}
						language={language}
						signupstatus={signupstatus}
						favorites={favorites}
						formphase={formphase}
						setActiveStep={setActiveStep}
						setFavorites={setFavorites}
						isJobTypesEnabled={isJobTypesEnabled}
					/>
				)}
				<Collapse
					in={activeStep === 1}
				>
					{!signupstatus.result && contentLoaded && "registration" === formphase &&
						<CompanyPriorities
							companies={companies}
							language={language}
							favorites={favorites}
							setActiveStep={setActiveStep}
							setFavorites={setFavorites}
							participant={participant}
							handleFieldChange={handleFieldChange}
						/>
					}
				</Collapse>
				<Collapse
					in={activeStep === 2}
				>
					{!signupstatus.result && contentLoaded && "registration" === formphase &&
						<>
							<Typography variant="h3">
								{language === "en" ? "About you" : "Über Dich"}
							</Typography>
							{printContactFields()}
							<br />
							<br />
							<Grid item xs={12} align="center">
								<Button
									color="primary"
									variant="contained"
									onClick={() => {
										const relevantFields = [
											"salutation",
											"firstname",
											"lastname",
											"email",
											"phone",
											"vita"
										];
										if (fields.hasOwnProperty("job_status")) {
											relevantFields.push("job_status");
										}
										if (fields.hasOwnProperty("education")) {
											relevantFields.push("education");
										}
										if (fields.hasOwnProperty("formerrole")) {
											relevantFields.push("formerrole");
										}
										if (fields.hasOwnProperty("german")) {
											relevantFields.push("german");
										}
										if (fields.hasOwnProperty("english")) {
											relevantFields.push("english");
										}

										const errors = checkFormForErrors(participant);

										// check whether one of the relevant fields is contained as a key in fieldErrors
										const relevantFieldsWithErrors = relevantFields.filter(accessor => errors.fieldErrors[accessor] !== "");
										const newFieldShowErrors = { ...fieldShowErrors };
										if (newFieldShowErrors) {
											Object.keys(newFieldShowErrors).forEach((fieldname) => {
												if (relevantFields.indexOf(fieldname) > -1) {
													newFieldShowErrors[fieldname] = true;
												}
											});

											setFieldShowErrors(newFieldShowErrors);
										}
										if (relevantFieldsWithErrors.length === 0) {
											setActiveStep(3);
										}
									}}
								>
									{language === "en" ? "continue >" : "weiter >"}
								</Button>
								<br />
								<br />
								<Button
									size="small"
									onClick={() => {
										setActiveStep(1);
									}}
								>
									{language === "en" ? "back" : "zurück"}
								</Button>
							</Grid>
						</>
					}
				</Collapse>
				<Collapse
					in={activeStep === 3}
				>
					{!signupstatus.result && contentLoaded && "registration" === formphase &&
						<>
							<Typography variant="h3">{language === "en" ? "Additional information" : "Sonstiges"}</Typography>
							{fields.hasOwnProperty('workshop') &&
								<>
									<br />
									<br />
									<Grid item xs={12}>
										<FormControl
											required={fields.workshop.required}
											error={
												fieldErrors.workshop !== "" && fieldShowErrors.workshop
											}
										>
											<FormControlLabel
												control={
													<Checkbox
														id="workshop"
														name="workshop"
														checked={participant.workshop}
														onChange={handleFieldChange}
													/>
												}
												label={
													<span
														dangerouslySetInnerHTML={{
															__html: fields.workshop.label,
														}}
														style={{ whiteSpace: "pre-line" }}
													/>
												}
											/>
											<FormHelperText>
												{fieldShowErrors.workshop ? fieldErrors.workshop : ""}
											</FormHelperText>
										</FormControl>
									</Grid>
								</>
							}
							<br />
							<br />

							{printOtherFields()}
							<Paper className={classes.actionsContainer}>
								<div>
									{formErrors.map((error, error_index) => (
										<Typography key={"error-" + error_index}>
											{error}
										</Typography>
									))}
								</div>

								<Button
									variant="contained"
									color="primary"
									onClick={() => {
										const relevantFields = [
											"find_us",
											"accept_privacy",
											"accept_terms",
										];

										// check whether one of the relevant fields is contained as a key in fieldErrors
										const relevantFieldsWithErrors = relevantFields.filter(accessor => fieldErrors[accessor] !== "");
										const newFieldShowErrors = { ...fieldShowErrors };
										if (newFieldShowErrors) {
											Object.keys(newFieldShowErrors).forEach((fieldname) => {
												if (relevantFields.indexOf(fieldname) > -1) {
													newFieldShowErrors[fieldname] = true;
												}
											});

											setFieldShowErrors(newFieldShowErrors);
										}
										if (relevantFieldsWithErrors.length === 0) {
											submit();
										}
									}}
									className={classes.button}
									id={"button-next-" + activeStep}
									disabled={formErrors.length > 0 || signupstatus.waiting}
								>
									{language === "en"
										? "Send registration"
										: "Anmeldung absenden"
									}
								</Button>
								<br />
								{/* <Button
									onClick={() => {
										ls.set("participant", {});
										ls.set("favorites", []);
										window.location.reload();
									}}
									className={classes.button}
									size="small"
									id={"button-reset-" + activeStep}
								>
									{language === "en"
										? "Delete entries"
										: "Eingaben löschen"
									}
								</Button> */}
								<Button
									size="small"
									onClick={() => {
										setActiveStep(2);
									}}
								>
									{language === "en" ? "back" : "zurück"}
								</Button>
							</Paper>
						</>
					}
				</Collapse>
				<br />
				<br />
			</main>
		</MuiThemeProvider >
	);
};
export default withStyles(styles)(SignupForm);
